import axios from "axios";

const api_host = process.env.NODE_ENV !== 'production' ? 
    "http://localhost:3001" : 
    "https://www.coeladvocaten.be";

export const getHost = () => {
  return api_host;
};

const getUrl = endpoint => api_host + "/api" + endpoint;

export const post = async (endpoint, data, token) => {
  return axios.post(getUrl(endpoint), data, {
    headers: { "Content-Type": "application/json", "x-access-token": token }
  });
};

export const put = async (endpoint, data, token) => {
  return axios.put(getUrl(endpoint), data, {
    headers: { "Content-Type": "application/json", "x-access-token": token }
  });
};

export const remove = async (endpoint, token) => {
  return axios.delete(getUrl(endpoint), {
    headers: { "Content-Type": "application/json", "x-access-token": token }
  });
};

export const get = async (endpoint, token) => {
  if (token !== null && token !== undefined) {
    var config = {
      headers: {"x-access-token": token}
    };
    
    return axios.get(getUrl(endpoint), config);
  }
    
  return;
};